import * as Yup from 'yup'

const translationSchema = Yup.object().shape({
  value: Yup.string().required('validation-required'),
  ai_translation: Yup.string(),
  helper_text: Yup.string().nullable(),
})

export { translationSchema }
